import { fetchAuthSession } from 'aws-amplify/auth';

type ConnectOptions = {
  protocols?: string | string[];
  params?: Record<string, string | number | boolean | undefined>;
  organizationID?: string;
};

/**
 * Opens an authenticated WebSocket connection to the billing Web Socket API.
 * The Cognito ID token is sent as the `token` query param for the Lambda authorizer.
 */
export const connect = async (
  options: ConnectOptions = {}
): Promise<WebSocket> => {
  const endpoint = import.meta.env.VITE_WEB_SOCKET_API_ENDPOINT;
  if (!endpoint) {
    throw new Error('VITE_WEB_SOCKET_API_ENDPOINT is not configured');
  }

  const session = await fetchAuthSession();
  const token = session.tokens?.idToken?.toString();
  if (!token) {
    throw new Error('Missing auth token for WebSocket connection');
  }

  const { protocols, params } = options;
  const url = new URL(endpoint);

  url.searchParams.set('token', token);
  if (options.organizationID != null) {
    url.searchParams.set('organizationID', options.organizationID);
  }

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        url.searchParams.set(key, String(value));
      }
    });
  }

  return new WebSocket(url.toString(), protocols);
};
